/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Gokul",
  logo_name: "<Gokul/>",
  nickname: "Gokul",
  full_name: "Gokul",
  subTitle:
    "Full Stack Developer, Machine Learning Enthusiast. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1HYnbh0KP-IpJY9_AHI2jwB62CY99uVHN/view?usp=sharing",
  mail: "mailto:gokul142003@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/Gokul-77",
  linkedin: "https://www.linkedin.com/in/gokul-selvaraj-a3b65a213",
  gmail: "gokul142003@gmail.com",
  gitlab: " ",
  facebook: " ",
  twitter: "",
  instagram: "",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using ReactJS ",
        "⚡ Developing mobile applications using Flutter",
        "⚡ Backend development using NodeJS, Django and Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },

        {
          skillName: "Java",
          fontAwesomeClassname: "logos-java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: {
            color: "#5c79df",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },

        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#029FCE",
          },
        },

        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos-node-js",
          style: {
            color: "#339933",
          },
        },

        {
          skillName: "Android App Development",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },

        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },

    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing web apps",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
      ],
      softwareSkills: [
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },

        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
      ],
    },
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Experience with real-time Projects",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "numpy",
          fontAwesomeClassname: "simple-icons:numpy",
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#6E6E6E",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Dhanalakshmi Srinivasan Engineering College",
      subtitle: "B.E - Computer Science and Engineering",
      logo_path: "au.png",
      alt_name: "DAL",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ Studied Advanced Software Development Concepts, Data Management & Warehousing",
        "⚡ Learn Advanced Topics in Cloud Computing, Cloud Architecture along with Serverless Computing",
        "⚡ Worked on projects on courses like Mobile Computing and Web Technologies.",
      ],
      website_link: "https://www.dsengg.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Python pro Bootcamp",
      subtitle: "2023",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-8f9b35f3-5734-44db-bd7c-e729f4c07d62/",
      alt_name: "AWS",
      color_code: "white",
    },
    {
      title: "Web Development Bootcamp",
      subtitle: "2024",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-18b5df24-f8ed-4ae4-8b3c-1fe2f7984d8b/",
      alt_name: "AWS",
      color_code: "white",
    },
    {
      title: "React JS ",
      subtitle: "2024",
      logo_path: "great_learning.png",
      certificate_link:
        "https://olympus.mygreatlearning.com/courses/52045/certificate",
      alt_name: "Google",
      color_code: "white",
    },
    {
      title: "Frontend Development",
      subtitle: "HTML",
      logo_path: "great_learning.png",
      certificate_link:
        "https://olympus.mygreatlearning.com/courses/12761/certificate",
      alt_name: "Google",
      color_code: "white",
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Machine Learing Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact_me.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try my best to write a blog about it.",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "E-Commerce Website",
      url: "https://github.com/Gokul-77/E-commerce_website",
      description: "A one of the E-learning platform website.",
      languages: [
        {
          name: "HTML",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS",
          iconifyClass: "devicon-css3",
        },
      ],
    },

    {
      name: "Calculator",
      url: "",
      description:
        "A simple interactive calculator that performs basic arithmetic operations.",
      languages: [
        {
          name: "HTML",
          iconifyClass: "devicon-html5",
          color: "white",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Portfolio",
      url: "",
      description: "(This) A clean and full customizable portfolio template.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      name: "Gesture Language Recognition",
      url: " ",
      description:
        "A hand gesture recognition system to bridge communication between deaf/mute individuals and others.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Tensorflow",
          iconifyClass: "logos-tensorflow",
        },
        {
          name: "OpenCV",
          iconifyClass: "logos-opencv",
        },
        {
          name: "Keras",
          iconifyClass: "devicon-keras",
        },
        {
          name: "Matplotlib",
          iconifyClass: "logos-matplotlib",
        },
        {
          name: "Mediapipe",
          iconifyClass: "devicon-mediapipe",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  projectsHeader,
  contactPageData,
  projects,
};
